// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tool_toolContainer__oPqUU {
  padding: 30px;
  max-width: 550px;
  width: 100%;
}

.tool_toolContent__vKrXU {
  background: var(--white);
  border-radius: 6px;
}

.tool_toolHeader__E6Z-A {
  padding-bottom: 20px;
  /* border-bottom: 1px solid var(--lightgrey); */
  margin-bottom: 0px;
}

.tool_toolTitle__mjzaE {
  font-weight: 600;
  font-size: 20px;
  color: var(--cloudburst);
  margin: 0 0 6px 0;
}

.tool_toolDescription__IWyGt {
  font-size: 14px;
  color: var(--grey);
  margin: 0;
  line-height: 1.5;
  padding-top: 15px;
  border-top: 1px solid var(--lightgrey);
}

.tool_formGroup__B8CmD {
  display: flex;
  flex-direction: row;
  gap: 55px;
  padding-block: 20px;
}

.tool_formLabel__jr2k5 {
  font-weight: 500;
  font-size: 14px;
  color: var(--cloudburst);
  display: flex;
  align-items: center;
  gap: 8px;
}

.tool_premiumBadge__73215 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tool_inputWrapper__4qGNG {
  position: relative;
  width: 100%;
}

.tool_currencyPrefix__a11Qy {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  font-weight: 500;
  color: var(--grey);
  pointer-events: none;
  z-index: 1;
}

.tool_numberInput__J-xh4 {
  width: 100%;
  height: 45px;
  padding: 10px 14px 10px 28px;
  background: var(--white);
  border: 1px solid var(--ashyblue);
  border-radius: 6px;
  outline: none;
  font-size: 15px;
  font-weight: 500;
  color: var(--darkblue);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  -moz-appearance: textfield;
}

.tool_numberInput__J-xh4::-webkit-outer-spin-button,
.tool_numberInput__J-xh4::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.tool_numberInput__J-xh4:focus {
  border-color: var(--cloudburst);
  box-shadow: 0 0 0 3px rgba(52, 64, 84, 0.08);
}

.tool_numberInput__J-xh4::placeholder {
  color: var(--grey);
  font-weight: 400;
  font-size: 14px;
}

.tool_numberInput__J-xh4.tool_inputError__w5H-V {
  border-color: #d92d20;
  box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.08);
}

.tool_helpText__A1J1k {
  font-size: 13px;
  color: var(--grey);
  margin: 4px 0 0 0;
  line-height: 1.4;
}

.tool_errorText__CSGLP {
  font-size: 13px;
  color: #d92d20;
  margin: 4px 0 0 0;
  line-height: 1.4;
}

.tool_saveButtons__C7rhT {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 25px;
  padding-top: 25px;
  border-top: 1px solid var(--lightgrey);
}

.tool_saveButton__1v9QT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  line-height: 22px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  background-color: #000;
  border: 1px solid transparent;
  padding: 8px 20px;
  min-height: 42px;
  min-width: 144px;
  text-align: center;
  transition: background-color 0.2s ease;
}

.tool_saveButton__1v9QT:hover:not(:disabled) {
  background-color: #1a1a1a;
}

.tool_saveButton__1v9QT:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Stats preview section */
.tool_statsPreview__kqS9- {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  padding-top: 12px;
}

.tool_statItem__EKAeQ {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tool_statLabel__kYjla {
  font-size: 12px;
  color: var(--grey);
  font-weight: 400;
}

.tool_statValue__w9RT0 {
  font-size: 18px;
  font-weight: 600;
  color: var(--cloudburst);
}

.tool_billSection__Oa9YS .tool_numberInput__J-xh4 {
  padding: 10px
}

.tool_billSection__Oa9YS textarea.tool_numberInput__J-xh4 {
  max-height: 200px;
  min-height: 90px;
}

.tool_billSection__Oa9YS label {
  min-width: 80px;
  max-width: 80px
}

.tool_billSection__Oa9YS .tool_formGroup__B8CmD div {
  width: 100%
}

/* Responsive */
@media screen and (max-width: 768px) {
  .tool_toolContainer__oPqUU {
    padding: 20px;
  }

  .tool_toolContent__vKrXU {
    padding: 22px;
  }

  .tool_inputWrapper__4qGNG {
    max-width: 100%;
  }

  .tool_statsPreview__kqS9- {
    gap: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Appearance/Tool/tool.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".toolContainer {\n  padding: 30px;\n  max-width: 550px;\n  width: 100%;\n}\n\n.toolContent {\n  background: var(--white);\n  border-radius: 6px;\n}\n\n.toolHeader {\n  padding-bottom: 20px;\n  /* border-bottom: 1px solid var(--lightgrey); */\n  margin-bottom: 0px;\n}\n\n.toolTitle {\n  font-weight: 600;\n  font-size: 20px;\n  color: var(--cloudburst);\n  margin: 0 0 6px 0;\n}\n\n.toolDescription {\n  font-size: 14px;\n  color: var(--grey);\n  margin: 0;\n  line-height: 1.5;\n  padding-top: 15px;\n  border-top: 1px solid var(--lightgrey);\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: row;\n  gap: 55px;\n  padding-block: 20px;\n}\n\n.formLabel {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--cloudburst);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.premiumBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: linear-gradient(135deg, #f59e0b, #d97706);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.inputWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.currencyPrefix {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--grey);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.numberInput {\n  width: 100%;\n  height: 45px;\n  padding: 10px 14px 10px 28px;\n  background: var(--white);\n  border: 1px solid var(--ashyblue);\n  border-radius: 6px;\n  outline: none;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--darkblue);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  -moz-appearance: textfield;\n}\n\n.numberInput::-webkit-outer-spin-button,\n.numberInput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.numberInput:focus {\n  border-color: var(--cloudburst);\n  box-shadow: 0 0 0 3px rgba(52, 64, 84, 0.08);\n}\n\n.numberInput::placeholder {\n  color: var(--grey);\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.numberInput.inputError {\n  border-color: #d92d20;\n  box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.08);\n}\n\n.helpText {\n  font-size: 13px;\n  color: var(--grey);\n  margin: 4px 0 0 0;\n  line-height: 1.4;\n}\n\n.errorText {\n  font-size: 13px;\n  color: #d92d20;\n  margin: 4px 0 0 0;\n  line-height: 1.4;\n}\n\n.saveButtons {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 25px;\n  padding-top: 25px;\n  border-top: 1px solid var(--lightgrey);\n}\n\n.saveButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  line-height: 22px;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n  background-color: #000;\n  border: 1px solid transparent;\n  padding: 8px 20px;\n  min-height: 42px;\n  min-width: 144px;\n  text-align: center;\n  transition: background-color 0.2s ease;\n}\n\n.saveButton:hover:not(:disabled) {\n  background-color: #1a1a1a;\n}\n\n.saveButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Stats preview section */\n.statsPreview {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  padding-top: 12px;\n}\n\n.statItem {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.statLabel {\n  font-size: 12px;\n  color: var(--grey);\n  font-weight: 400;\n}\n\n.statValue {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--cloudburst);\n}\n\n.billSection .numberInput {\n  padding: 10px\n}\n\n.billSection textarea.numberInput {\n  max-height: 200px;\n  min-height: 90px;\n}\n\n.billSection label {\n  min-width: 80px;\n  max-width: 80px\n}\n\n.billSection .formGroup div {\n  width: 100%\n}\n\n/* Responsive */\n@media screen and (max-width: 768px) {\n  .toolContainer {\n    padding: 20px;\n  }\n\n  .toolContent {\n    padding: 22px;\n  }\n\n  .inputWrapper {\n    max-width: 100%;\n  }\n\n  .statsPreview {\n    gap: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolContainer": `tool_toolContainer__oPqUU`,
	"toolContent": `tool_toolContent__vKrXU`,
	"toolHeader": `tool_toolHeader__E6Z-A`,
	"toolTitle": `tool_toolTitle__mjzaE`,
	"toolDescription": `tool_toolDescription__IWyGt`,
	"formGroup": `tool_formGroup__B8CmD`,
	"formLabel": `tool_formLabel__jr2k5`,
	"premiumBadge": `tool_premiumBadge__73215`,
	"inputWrapper": `tool_inputWrapper__4qGNG`,
	"currencyPrefix": `tool_currencyPrefix__a11Qy`,
	"numberInput": `tool_numberInput__J-xh4`,
	"inputError": `tool_inputError__w5H-V`,
	"helpText": `tool_helpText__A1J1k`,
	"errorText": `tool_errorText__CSGLP`,
	"saveButtons": `tool_saveButtons__C7rhT`,
	"saveButton": `tool_saveButton__1v9QT`,
	"statsPreview": `tool_statsPreview__kqS9-`,
	"statItem": `tool_statItem__EKAeQ`,
	"statLabel": `tool_statLabel__kYjla`,
	"statValue": `tool_statValue__w9RT0`,
	"billSection": `tool_billSection__Oa9YS`
};
export default ___CSS_LOADER_EXPORT___;
